// eslint-disable-next-line import/prefer-default-export
export const LAYOUT_OPTIONS = {
  layout1: 1,
  layout2: 2,
  layout3: 3,
  layout4: 4,
  layout5: 5,
};
